export default __webpack_public_path__ + "static/media/ToyotaBG.e9dfc32e.png";